module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAA9UlEQVRYhe2XMQrCMBhGn0Xc9R7tiXR0dVNcegGd3N28Ue+hjoJLJdJKCKko6J8WvgelafqHPkqS9kOIbkZ5nk+APTB318AJWAP3qqqeA4uicCe/bpbgnV5btzGwA1beTde+AdtgUFhnzbR1y4BF5OHLSF+sLgXLrCciX5E18yTkGOmL1aXg6Ob0plmAC0+ujMj4ddMEsu1CLN3u0VkV7B69YVTXda+EPmGwC3FwSNoKSVshaSsG+UXMmp/7A3AGLk17Eqn16+oEx8tNIcAIhQArFALMUAiwQtJWSNoKSVuhEGCFQsCfUQgwRyHgz1zfuInfAzwALdiOatIiHDQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/分类.png
// module id = +V9S
// module chunks = 0